module.exports = __webpack_public_path__ + "img/others_08.12529cfe.jpg";